const adminTargetCapabilityBrand: unique symbol = Symbol('admin-target-capability');

export type AdminTargetCapability = Readonly<{
  readonly [adminTargetCapabilityBrand]: true;
}>;

const issuedCapabilities = new WeakSet<object>();

class CapabilityToken {
  readonly [adminTargetCapabilityBrand] = true as const;
}

// Imports of this mint are source-contract allowlisted to the administrator
// endpoint module. Runtime validation still rejects forged lookalikes.
export const issueAdminTargetCapability = (): AdminTargetCapability => {
  const capability = Object.freeze(new CapabilityToken());
  issuedCapabilities.add(capability);
  return capability;
};

export const isAdminTargetCapability = (value: unknown): value is AdminTargetCapability =>
  typeof value === 'object' && value !== null && issuedCapabilities.has(value);
